/**
 * Secret Key 초기화 Plugin
 * 앱 시작 시 Secret Key가 없거나 만료된 경우 자동으로 발급
 */

export default defineNuxtPlugin(async () => {
  if (import.meta.server) {
    return
  }

  const { initializeSecretKey } = useSecretKeyActions()
  const timestamp = new Date().toISOString()

  try {
    await initializeSecretKey()
  } catch (error) {
    console.error(`❌ [Plugin-${timestamp}] Secret Key 플러그인 실행 실패:`, error)
  }
})
